const Config = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL || 'https://form.zenit.world/api',
}

export default Config
